
export const getEntryPoint = () => (
  process.env.ENTRY_POINT
    ? process.env.ENTRY_POINT
    : 'abcp-widget-franchisees-offices-page'
);
